import createNavItemsViewModel from '@qpr/components/Expandable/nav-items-view-model';
import { LandingPage2View } from '@qpr/landing-page-2';
import React, { useContext, useEffect } from 'react';
import AppBarContext from '../components/BusinessPortalAppBarContext';

const LandingPage = () => {
  const viewmodel = createNavItemsViewModel();
  const appBarContext = useContext(AppBarContext);

  useEffect(() => {
    appBarContext.setAppBar(false);
  }, [appBarContext]);

  return <LandingPage2View navItemsViewModel={viewmodel} />;
};

export default LandingPage;
